__turbopack_context__.v({
  "button": "styles-module-scss-module__DRdskq__button",
  "noImage": "styles-module-scss-module__DRdskq__noImage",
  "thumbnail": "styles-module-scss-module__DRdskq__thumbnail",
  "wrapper": "styles-module-scss-module__DRdskq__wrapper",
});
